var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"}}),(!_vm.results)?_c('CalculateForm',{on:{"onResults":_vm.onResults}}):_vm._e(),_c('CalculateResults',{attrs:{"results":_vm.results}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }